<wen-menu-item (click)="onClickSignOut()">
  <wen-icon-log-out icon></wen-icon-log-out><span i18n>Disconnect</span>
</wen-menu-item>
